export default __webpack_public_path__ + "02a325cc010cdd3e27415145bf6a83b8.svg";